export const CREATE_MY_MUSIC_COLLECTION = 'CREATE_MY_MUSIC_COLLECTION';
export const GET_MY_MUSIC_COLLECTIONS = 'GET_MY_MUSIC_COLLECTIONS';
export const REMOVE_MY_MUSIC_COLLECTION = 'REMOVE_MY_MUSIC_COLLECTION';
